export default __webpack_public_path__ + "static/media/bank-mastercard.23e45e6d.svg";